import React, { Component } from "react";

import { connect } from "react-redux";
import {} from "../../_actions";

import ViewHeader from "./view-header";
import ViewContent from "./view-content";

import "./style.css";

class PaymentUpload extends Component {
  render() {
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { authentication } = state;
  const { user } = authentication;
  return user;
}

export default connect(mapStateToProps)(PaymentUpload);



// WEBPACK FOOTER //
// ./src/views/payment-upload/index.js